<div class="flex flex-col gap-2">
    <p-confirmpopup
        acceptLabel="Yes"
        key="removeComponentSegmentRelationRowPopup"
        rejectLabel="No"
        [baseZIndex]="8000"
    ></p-confirmpopup>
    <div class="flex justify-between items-center">
        <label>Segment Relations</label>
        <p-button
            icon="pi pi-plus"
            [text]="true"
            [disabled]="isLoading"
            pTooltip="Add segment relation"
            tooltipPosition="bottom"
            [showDelay]="500"
            (click)="addRow()"
        ></p-button>
    </div>
    <div class="st-border">
        <p-table [value]="rows" dataKey="rowId">
            <ng-template #header>
                <tr>
                    <th>Segment</th>
                    <th class="w-20">Active</th>
                    <th class="w-4"></th>
                </tr>
            </ng-template>
            <ng-template #body let-row>
                <tr>
                    <td>
                        <p-select
                            appendTo="body"
                            [options]="segments"
                            optionLabel="displayName"
                            optionValue="key"
                            [filter]="true"
                            [loading]="isLoading || segmentsIsLoading"
                            [placeholder]="
                                isLoading || segmentsIsLoading
                                    ? 'Loading segment...'
                                    : 'Select segment'
                            "
                            [style]="{ width: '100%' }"
                            [disabled]="!row.isNew || isLoading"
                            [ngModel]="row.segmentAnchorKey"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onSegmentChange(row, $event)"
                            (onShow)="onShowSegments()"
                            (onFilter)="onSearchSegments($event.filter)"
                        ></p-select>
                    </td>
                    <td class="w-20">
                        <p-toggleSwitch
                            [ngModel]="row.isActive"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onIsActiveChange(row, $event)"
                        ></p-toggleSwitch>
                    </td>
                    <td class="w-4">
                        @if (row.isNew) {
                            <p-button
                                icon="pi pi-trash"
                                [text]="true"
                                severity="danger"
                                pTooltip="Remove unsaved row"
                                tooltipPosition="bottom"
                                [showDelay]="500"
                                (click)="confirmRemoveUnsavedRow(row, $event)"
                            ></p-button>
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td colspan="3" class="text-center" role="status">
                        @if (isLoading) {
                            <i class="pi pi-spin pi-spinner mr-2" aria-hidden="true"></i>
                            Loading segment relations...
                        } @else {
                            No result
                        }
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
